module.exports = __webpack_public_path__ + "img/agriculture-24.4947d2b5.svg";